import * as $ from 'jquery';
import { apiBaseUrlUser } from "../../../constants/url.constant";
import { DefaultService } from "../../common/services/DefaultService";
import { PreferenceModel, RecommendedProductFilterModel } from "../../products/models/ProductModel";

export class PreferenceService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/preference`

    public RouteGetFavorites = (customerId: number) => `${this.baseUrl}/getFavorites/${customerId}`;
    public getFavorites(customerId: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetFavorites(customerId), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetRecentViews = (customerId: number) => `${this.baseUrl}/getRecentViews/${customerId}`;
    public getRecentViews(customerId: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetFavorites(customerId), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetRecommendedProducts = (customerId: number) => `${this.baseUrl}/getRecommendedProducts/${customerId}`;
    public getRecommendedProducts(customerId: number, model: RecommendedProductFilterModel): JQueryPromise<any> {
        return $.ajax(this.RouteGetRecommendedProducts(customerId), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteCreate = () => `${this.baseUrl}/create`;
    public create(model: PreferenceModel): JQueryPromise<any> {
        return $.ajax(this.RouteCreate(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteDelete = () => `${this.baseUrl}/delete`;
    public delete(model: PreferenceModel): JQueryPromise<any> {
        return $.ajax(this.RouteDelete(), {
            type: 'delete',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteExecuteSummary = () => `${this.baseUrl}/executeSummary`;
    public executeSummary(): JQueryPromise<any> {
        return $.ajax(this.RouteExecuteSummary(), {
            type: 'post',
            contentType: 'application/json'
        });
    }
}